import React from "react";
import me from "../../assets/imgs/me.jpg";
import {
  BsTwitter,
  BsFacebook,
  BsLinkedin,
  BsFillBookmarksFill,
} from "react-icons/bs";

import { BiLike } from "react-icons/bi";
import { FaRegCommentDots, FaCopy } from "react-icons/fa";
import { useLocation } from "react-router-dom";

export default function EachSaved({ ownSaved }) {
  let location = useLocation();
  return (
    <div className="each">
      {ownSaved.map((item, i) => {
        if (item.id === location.pathname.split("/").at(-1)) {
          return (
            <div key={i} className="bosh-container">
              <div className="btn-div">
                <div className="heade-flex">
                  <div className="div-img">
                    <img src={me} alt="me" />
                    <div className="me-info">
                      <h3>Shakhzod </h3>
                      <p>Jun 21, 1 minute read</p>
                    </div>
                  </div>

                  <div className="icons">
                    <BsTwitter />
                    <BsFacebook />
                    <BsLinkedin />
                    <BsFillBookmarksFill />
                  </div>
                </div>

                <div className="desc">
                  <h1>{item.decs}</h1>
                  <h2>{item.decs}</h2>
                </div>

                <div className="like-s">
                  <div className="one">
                  <FaRegCommentDots />
                  <BiLike />
                  </div>
                  <div className="two">
                    <FaCopy />
                  <BsFillBookmarksFill />
                  </div>
                </div>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
}
